/* eslint-disable no-script-url */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import sessionActions from '../../actions/SessionActions';
import { t } from '../../services/i18nService';
import uiActions from '../../actions/UIActions';
import uiConstants, { UI_OPTIONS_LIST } from '../../constants/UIConstants';
import storeManager from '../../store/StoreManager';
import styles from './options.scss';

import OptionsTopBar from './OptionsTopBar';
import OptionsChoiceList from './OptionsChoiceList';
import { getA11yAttributesV2 } from '../../services/a11yIIBScreenReaderService';
import uiService from '../../services/UIService';

class OptionsZoomFactorChooser extends React.Component {
    static propTypes = {
        ui: PropTypes.object,
    };

    /**
     * @param {string} factor: zoom-small, zoom-medium or zoom-large
     * */
    handleZoomFactorChange = (factor) => {
        const store = storeManager.getStore();
        store.dispatch(uiActions.uiSetZoomFactor(factor));
        uiService.setUISettingInLocalStorageForTestTaker(
            UI_OPTIONS_LIST.ZOOM_FACTOR,
            factor
        );
    };

    render() {
        const { ui } = this.props;
        /*
            Based on whether the local storage is available for zoom factor,
            we are storing the value in savedOrDefaultZoomFactor.
            If it is available, then we store that value, otherwise the default value
        */
        const savedOrDefaultZoomFactor = uiService.getUISettingFromLocalStorageForTestTaker(
            UI_OPTIONS_LIST.ZOOM_FACTOR
        );
        const current = ui.zoomFactor ? ui.zoomFactor : savedOrDefaultZoomFactor;
        const choices = Object.values(uiConstants.ZOOM_FACTOR).map(factor => ({
            identifier: factor,
            title: t(`options.${factor}`),
            isSelected: current === factor,
            a11yLabel: `${t('options.zoom-title')}, ${t(`options.${factor}`)}`,
        }));

        return (
            <div>
                <OptionsTopBar
                    title={t('options.zoom-title')}
                    showOptionsButton
                    exitButtonProps={getA11yAttributesV2({ 'aria-label': t('options.closeOptionsMenu') })}
                    optionsButtonProps={getA11yAttributesV2({ 'aria-label': t('options.backToOptionsList') })}
                />
                <div className={styles.mainContentArea} role="main">
                    <OptionsChoiceList
                        selectionHandler={this.handleZoomFactorChange}
                        choices={choices}
                        {...getA11yAttributesV2({ a11yLabel: t('options.zoom-title') })}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ui: state.ui,
    };
}

const OptionsZoomFactor = connect(mapStateToProps, sessionActions)(OptionsZoomFactorChooser);
export default OptionsZoomFactor;
